// export const SUPPORTED_CHAIN_ID = parseInt(
//   process.env.VUE_APP_SUPPORTED_CHAIN_ID
// );
export const SUPPORTED_CHAIN_ID = process.env.VUE_APP_SUPPORTED_CHAIN_ID;
export const RPC_URL = process.env.VUE_APP_RPC_URL;
export const BLOCKNATIVE_DAPP_ID = process.env.VUE_APP_BLOCKNATIVE_DAPP_ID;
export const ASSETS_URL = process.env.VUE_APP_ASSETS_URL;
export const BASE_URL = process.env.VUE_APP_FARM_API;